import { capture } from "./capture";

export const QueriesTracking = {
  /** All queries CSV downloaded. */
  downloaded: (query_count: number) => {
    capture("queries.downloaded", { query_count });
  },

  /** Query detail page viewed. */
  detailViewed: (query_id: string) => {
    capture("queries.detail_viewed", { query_id });
  },

  /** AI explanation requested for a query. */
  aiExplanationRequested: (query_id: string) => {
    capture("queries.ai_explanation_requested", { query_id });
  },

  /** Lineage / SQL Visualizer tab viewed. */
  lineageViewed: (query_id: string) => {
    capture("queries.lineage_viewed", { query_id });
  },

  /** Opportunity selected on query detail page. */
  opportunitySelected: (query_id: string, opportunity_id: string) => {
    capture("queries.opportunity_selected", { query_id, opportunity_id });
  },

  /** Group name edited. */
  groupNameEdited: (query_hash: string) => {
    capture("queries.group_name_edited", { query_hash });
  },

  /** Job detail page viewed. */
  jobDetailViewed: (workflow_id: string, workflow_type: string) => {
    capture("queries.job_detail_viewed", { workflow_id, workflow_type });
  },

  /** Runs compared. */
  runsCompared: (workflow_id: string) => {
    capture("queries.runs_compared", { workflow_id });
  },

  /** Run detail page viewed. */
  runDetailViewed: (workflow_id: string, run_id: string) => {
    capture("queries.run_detail_viewed", { workflow_id, run_id });
  },

  /** Chatbot opened on query detail page. */
  chatbotOpened: (query_id: string) => {
    capture("queries.chatbot_opened", { query_id });
  },
};
